/* ---- localization form ---- */
class LocalizationForm extends HTMLElement {
  constructor() {
    (super(),
      (this.elements = {
        input: this.querySelector(
          'input[name="locale_code"], input[name="country_code"]',
        ),
        button: this.querySelector("button"),
        panel: this.querySelector(".disclosure__list-wrapper"),
      }),
      this.elements.button.addEventListener(
        "click",
        this.openSelector.bind(this),
      ),
      this.addEventListener("keyup", this.onContainerKeyUp.bind(this)),
      this.querySelectorAll("a").forEach((t) =>
        t.addEventListener("click", this.onItemClick.bind(this)),
      ),
      document.addEventListener("click", this.handleClickOutside.bind(this)));
  }
  hidePanel() {
    (this.elements.button.setAttribute("aria-expanded", "false"),
      this.elements.panel.setAttribute("hidden", !0));
  }
  onContainerKeyUp(t) {
    "ESCAPE" === t.code.toUpperCase() &&
      (this.hidePanel(), this.elements.button.focus());
  }
  onItemClick(t) {
    t.preventDefault();
    let e = this.querySelector("form");
    ((this.elements.input.value = t.currentTarget.dataset.value),
      e && e.submit());
  }
  openSelector() {
    (this.elements.button.focus(),
      this.elements.panel.toggleAttribute("hidden"),
      this.elements.button.setAttribute(
        "aria-expanded",
        (
          "false" === this.elements.button.getAttribute("aria-expanded")
        ).toString(),
      ));
  }
  handleClickOutside(t) {
    this.contains(t.target) || this.hidePanel();
  }
}
customElements.define("localization-form", LocalizationForm);
